// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress-upload_progress__qjKrx","percent":"progress-upload_percent__XYDpR","player":"progress-upload_player__XtOop"};